import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useManualTimer } from '../../../../auth/hooks/timer';
import {
  NOTIFICATION_TYPES,
  useNotification,
} from '../../../../../components/Notification';
import { useMytaverseEvent } from '../../../providers';

import { getNotification } from '../../../../../components/Notification/helpers';

import { mytaverseWebsocketLogger } from '../../../../../providers/MytaverseProvider';

import { UseHandleUEConnectionType } from './interfaces';

import { StreamingProviders } from '../../../providers/MytaverseEventProvider/interfaces';

import { GameCastStreamSession } from '../GameCast/interfaces';

export const useHandleUEConnection: UseHandleUEConnectionType = () => {
  const {
    isTeleporting,
    isTeleportingToRoomByUnreal,
    setIsTeleportingToRoomByUnreal,
    setUe5WebsocketConnected,
    streamingProvider,
    setUe5CoreWeaveDisabled,
    gameCastVideoRef,
    currentParticipant,
    initMessageHandler,
    gameCastStreamId,
    gameCastStreamRegion,
  } = useMytaverseEvent();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [streamSession, setStreamSession] =
    useState<GameCastStreamSession | null>(null);
  const { intervalId, startTimer, clearTimer } = useManualTimer();
  const { showNotification } = useNotification();
  const { t: translate } = useTranslation('common');

  const isTeleportRun = isTeleporting || isTeleportingToRoomByUnreal;

  // useEffect(() => {
  //   if (timer < 1 && !!intervalId) {
  //     clearTimer();
  //     showNotification(
  //       getNotification({
  //         message: translate('notifications.kickOutError'),
  //         type: NOTIFICATION_TYPES.ERROR,
  //         withReloadButton: true,
  //         closeManually: true,
  //       }),
  //     );
  //     reloadPageTimeout(120, 'UE5 disconnected');
  //   }
  // }, [clearTimer, intervalId, showNotification, timer, translate]);

  const handleUe5WsConnected = useCallback(() => {
    mytaverseWebsocketLogger.log('UE5 connected');

    setTimeout(() => {
      setUe5WebsocketConnected(true);
    }, 8000);

    if (streamingProvider === StreamingProviders.CoreWeave) {
      setTimeout(() => {
        setUe5CoreWeaveDisabled(false);
      }, 8000);
    }

    if (isTeleportRun) {
      if (isTeleportingToRoomByUnreal) {
        setIsTeleportingToRoomByUnreal(false);
      }
    }

    if (intervalId) {
      clearTimer();
    }
  }, [
    isTeleportingToRoomByUnreal,
    setIsTeleportingToRoomByUnreal,
    isTeleportRun,
    intervalId,
    clearTimer,
    streamingProvider,
  ]);

  const attemptGameCastReconnect = async () => {
    const initMessage = initMessageHandler();
    if (!initMessage) {
      return false;
    }

    if (
      !gameCastVideoRef ||
      !currentParticipant ||
      !gameCastStreamId ||
      !gameCastStreamRegion
    ) {
      return false;
    }

    // attempt to reconnect
    mytaverseWebsocketLogger.log('Attempting GameCast reconnect');
    showNotification(
      getNotification({
        message: translate('notifications.attemptReconnect'),
        type: NOTIFICATION_TYPES.WARNING,
        withReloadButton: false,
        closeManually: true,
      }),
    );
    // const streamSession = await initializeStreamReconnect(
    //   gameCastVideoRef,
    //   currentParticipant?.id,
    //   initMessage,
    //   gameCastStreamRegion,
    //   getUserBrowser(),
    //   'Test connection with gamecast',
    //   gameCastStreamId,
    //   gameCastStreamId,
    // );

    if (streamSession && setStreamSession) {
      setStreamSession(streamSession as any);
      return true;
    }

    return false;
  };

  const handleUe5WsDisconnected = useCallback(async () => {
    if (!isTeleportRun) {
      mytaverseWebsocketLogger.error('UE5 disconnected');
    } else {
      mytaverseWebsocketLogger.log('UE5 disconnected due teleport to room');
    }

    setUe5WebsocketConnected(false);

    //for CoreWeave there is no need to display notification and reload page
    if (streamingProvider === StreamingProviders.CoreWeave) {
      setUe5CoreWeaveDisabled(true);
      return;
    }

    if (isTeleportRun) {
      return;
    }

    // TODO: Reimplement AWS GC reconnection
    if (streamingProvider === StreamingProviders.GameCast) {
      try {
        handleUe5WsConnected();
      } catch (error) {
        mytaverseWebsocketLogger.error(error);
      }
    }

    startTimer();
  }, [isTeleportRun, startTimer, streamingProvider]);

  return {
    handleUe5WsConnected,
    handleUe5WsDisconnected,
  };
};
